export const GET_EMPLOYEE_REQUEST = 'GET_EMPLOYEE_REQUEST';
export const GET_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_SUCCESS';
export const GET_EMPLOYEE_FAILURE = 'GET_EMPLOYEE_FAILURE';

export const SET_EMPLOYEE_REQUEST = 'SET_EMPLOYEE_REQUEST';
export const SET_EMPLOYEE_SUCCESS = 'SET_EMPLOYEE_SUCCESS';
export const SET_EMPLOYEE_FAILURE = 'SET_EMPLOYEE_FAILURE';

export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_FAILURE = 'CREATE_EMPLOYEE_FAILURE';

export const UPDATE_EMPLOYEE_REQUEST = 'UPDATE_EMPLOYEE_REQUEST';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_FAILURE = 'UPDATE_EMPLOYEE_FAILURE';

export const ADD_EMPLOYEE_FILES_REQUEST = 'ADD_EMPLOYEE_FILES_REQUEST';
export const ADD_EMPLOYEE_FILES_SUCCESS = 'ADD_EMPLOYEE_FILES_SUCCESS';
export const ADD_EMPLOYEE_FILES_FAILURE = 'ADD_EMPLOYEE_FILES_FAILURE';

export const REMOVE_EMPLOYEE_FILE_REQUEST = 'REMOVE_EMPLOYEE_FILE_REQUEST';
export const REMOVE_EMPLOYEE_FILE_SUCCESS = 'REMOVE_EMPLOYEE_FILE_SUCCESS';
export const REMOVE_EMPLOYEE_FILE_FAILURE = 'REMOVE_EMPLOYEE_FILE_FAILURE';